import React from "react";
import {
  Jumbotron,
  Container,
  Button,
  Row,
  Col,
  Card,
  CardImg
} from "reactstrap";

import "./style.css";

import { Link } from "react-router-dom";

import "./style.css";

const Jumbo = props => {
  const isDesktop = props.isDesktop;
  return (
    <div>
      <Jumbotron className="homepage-jumbo" fluid>
        <Container fluid>
          <Row>
            <Col sm={{ size: 7, offset: 2 }}>
              <h1 className="text-left hero-statement">
                The Future of Business is Tech
              </h1>
              <p className="pb-xl-5 ">
                Be on a high-growth tech-career with project-based experiential
                learning, dedicated mentoring, career coaching, and financing.
                Our innovative Stay Relevant, Forever™ commitment stays with you
                through your career, making it easier to embrace future tech.
              </p>
            </Col>
          </Row>

          {isDesktop ? (
            <Row>
              <Col md={{ size: 7, offset: 2 }}>
                <Link to="/browse">
                  <Button className="courses-button justify-content-center">
                    Find Your Course
                  </Button>
                </Link>
              </Col>
            </Row>
          ) : (
            <Row className="justify-content-center pt-lg-4">
              <Col xs={{ size: 6 }} sm={{ size: 4 }} className="text-center">
                <Link to="/browse">
                  <Button className="hero-btn-mobile">Find Your Course</Button>
                </Link>
              </Col>
              <Col xs={{ size: 6 }} sm={{ size: 4 }} className="text-center">
                <Link to="/contact-us">
                  <Button className="applyNow-jumbo-btn">Contact Us</Button>{" "}
                </Link>
              </Col>
            </Row>
          )}
        </Container>
      </Jumbotron>
      <Col>
        <CardImg
          className="d-block d-sm-none"
          top
          width="100%"
          src="img/logos.png"
          alt="Card image cap"
        />
      </Col>
    </div>
  );
};

export default Jumbo;
